import { render, staticRenderFns } from "./match_score.vue?vue&type=template&id=486caafb&"
import script from "./match_score.vue?vue&type=script&lang=js&"
export * from "./match_score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports